import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-legend-pause",
  "use": "icon-legend-pause-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"icon-legend-pause\"><rect x=\".352\" width=\"24\" height=\"24\" rx=\"12\" fill=\"#4066D4\" /><path d=\"M10.1 16.505c-.4.346-1.08.1-1.08-.39v-8.23c0-.49.68-.736 1.08-.39l6.068 4.116a.5.5 0 0 1 0 .778l-6.069 4.116Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol